import { useToast } from '@sketch/toasts'

import { useRegisterCommandBarCommands } from '@sketch/modules-common'
import { useNavigateToFrame } from '../../canvas/hooks/useNavigateToFrame'
import { useInspectorContext } from '../FrameView/hooks/inspector'
import { useExportModal } from '../FrameView/components/FrameDetailInspector/sections/Exports/ExportModal'
import { createInspectCommands } from './createInspectCommands'

export const InspectCommandBarRegistration = () => {
  const { selectedElement, sketchSceneRootElement } = useInspectorContext()
  const { openExportModal } = useExportModal()
  const { showToast } = useToast()
  const navigateToFrame = useNavigateToFrame()

  useRegisterCommandBarCommands(
    'inspect',
    () =>
      createInspectCommands({
        navigateToFrame,
        openExportModal,
        selectedElement,
        showToast,
        sketchSceneRootElement,
      }),
    [selectedElement, sketchSceneRootElement?.elementUUID]
  )

  return null
}
